export default __webpack_public_path__ + "static/media/what-we-can.b9ee2a86.svg";